module.exports = __webpack_public_path__ + "static/media/fccWeb.1cd425b7.png";